var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":"upload-input","type":"file","multiple":_vm.multiple,"accept":"image/*"},on:{"change":_vm.uploadFile}})}
var staticRenderFns = []

export { render, staticRenderFns }